/* Little Nooks — custom interactions
   - Sticky ATC bar (PDP, mobile-first)
   - Reveal-on-scroll for .ln-reveal
   - PDP scroll behaviors
*/

(function () {
  "use strict";

  // ---------- REVEAL ON SCROLL ----------
  function initReveals() {
    if (!("IntersectionObserver" in window)) {
      document.querySelectorAll(".ln-reveal").forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -60px 0px" }
    );
    document.querySelectorAll(".ln-reveal").forEach((el) => obs.observe(el));
  }

  // ---------- STICKY ATC ----------
  function initStickyATC() {
    const bar = document.querySelector("[data-ln-sticky-atc]");
    if (!bar) return;

    const trigger = document.querySelector("[data-ln-sticky-atc-trigger]") || document.querySelector(".product-form__cart-submit");
    if (!trigger) return;

    const triggerObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // when the main ATC button is OUT of view, show the sticky bar
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            bar.classList.add("is-visible");
          } else {
            bar.classList.remove("is-visible");
          }
        });
      },
      { threshold: 0 }
    );
    triggerObs.observe(trigger);

    // wire the sticky bar's button to click the real ATC
    const stickyBtn = bar.querySelector("[data-ln-sticky-atc-btn]");
    if (stickyBtn) {
      stickyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        const realBtn = document.querySelector(".product-form__cart-submit, .product-single__cart-submit");
        if (realBtn && !realBtn.disabled) {
          realBtn.click();
        } else if (realBtn) {
          realBtn.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    }
  }

  // ---------- BOOT ----------
  function boot() {
    initReveals();
    initStickyATC();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
